import { isMobile } from "../../../App";
import DatePicker from "react-datepicker";
import {
  availableHippodromes,
  availableRuns,
  changeShownRun,
  handleOptionChanges,
  hippodromesSubject,
  shownRunSubject,
  statisticsOptions,
  statisticsOptionsSubject,
  statisticsSubject,
} from "../../../stores/statistics.store";
import { useEffect } from "react";
import { dateForRequest, useForceUpdate } from "../../../services/misc.functions";
import { ApiService } from "../../../services/http.service";
import _ from "lodash";

export default function StatisticsOptionsWidget() {
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    let subscriber = statisticsSubject.subscribe(() => {
      forceUpdate();
    });
    let statisticsOptionsSub = statisticsOptionsSubject.subscribe(() => {
      forceUpdate();
    });
    let shownRunSub = shownRunSubject.subscribe(() => {
      forceUpdate();
    });

    return () => {
      subscriber.unsubscribe();
      statisticsOptionsSub.unsubscribe();
      shownRunSub.unsubscribe();
    };
  }, []);

  const getHippodromes = () => {
    const api = new ApiService();
    api
      .start("post", "https://tjk-statistics.bitrelic.io/api/trainings/", {
        date: statisticsOptions.date ? dateForRequest(statisticsOptions.date) : null,
      })
      .then((response: any) => {
        if (response && response.data !== null) {
          const sortedHippodromes = _.sortBy(response.hippodromes, ["is_foreign"]);
          availableHippodromes.length = 0;
          availableHippodromes.push(...sortedHippodromes);
          availableRuns.splice(0, availableRuns.length);
          availableRuns.push(...response.data);

          const query = new URLSearchParams(window.location.search);
          const hipodrome_key = query.get("hipodrom");
          const matchedHippodrome = availableHippodromes.find(
            (hippodrome: any) => hippodrome.tjk_key === hipodrome_key?.toUpperCase()
          );

          if (matchedHippodrome) {
            handleOptionChanges(statisticsOptions.date, matchedHippodrome);
          } else {
            handleOptionChanges(statisticsOptions.date, availableHippodromes[0]);
          }

          statisticsSubject.next("update");
          hippodromesSubject.next(availableHippodromes);
          forceUpdate();
        }
      });
  };

  useEffect(() => {
    getHippodromes();
  }, [statisticsOptions.date]);

  return (
    <div className="statistics-options">
      <div className="row">
        <div className="col-6">
          <label>TARİH</label>
          <DatePicker
            className="date-input"
            dateFormat="dd/MM/yyyy"
            selected={statisticsOptions.date}
            locale="tr"
            onChange={(date: Date | null) =>
              handleOptionChanges(date ?? new Date(), statisticsOptions.selectedHippodrome)
            }
            minDate={new Date("2018-10-29")}
            maxDate={new Date(new Date().setDate(new Date().getDate() + 1))}
          />
        </div>

        <div className="col-6">
          <label>HİPODROM</label>
          {availableHippodromes.length > 0 && statisticsOptions.selectedHippodrome && (
            <select
              className="hippodrome-select"
              value={statisticsOptions.selectedHippodrome.tjk_key}
              onChange={(e) => {
                handleOptionChanges(
                  statisticsOptions.date,
                  availableHippodromes.find((hippodrome: any) => hippodrome.tjk_key === e.target.value)
                );
              }}
            >
              {availableHippodromes.map((item) => (
                <option key={item.tjk_key} value={item.tjk_key}>
                  {item.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    </div>
  );
}
